import { LANGS, useI18n } from '../../../../i18n/i18n'
import './language-switcher.scss'

export function LanguageSwitcher() {
  const { lang, setLang } = useI18n()
  return (
    <div className="lang-switcher" role="group" aria-label="Idioma">
      <span className="lang-switcher__globe" aria-hidden>🌐</span>
      {LANGS.map((l) => (
        <button
          key={l.code}
          className={`lang-switcher__btn${l.code === lang ? ' is-active' : ''}`}
          onClick={() => setLang(l.code)}
          aria-pressed={l.code === lang}
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}
